<script setup lang="ts">
import { computed } from 'vue';

import { translate } from '@/shared/i18n';

const { content, deleted } = defineProps<{
  content: string;
  deleted: boolean;
}>();

const displayContent = computed<string>(() => {
  if (deleted) {
    return translate('chat.replyMessageDeleted');
  }

  return content || translate('chat.replyMessageWithoutText');
});
</script>

<template>
  <div class="min-w-0 rounded-r-md border-l-2 border-current bg-transparent py-1 pr-2 pl-2">
    <span class="block truncate text-sm leading-tight text-inherit">
      {{ displayContent }}
    </span>
  </div>
</template>
